import { TNotification } from 'src/providers/notification.provider'
import { TRedirectReason } from './auth.type'
import { useTranslation } from 'react-i18next'

export default function useNotificationContent() {
  const { t } = useTranslation()

  const NOTIFICATION_CONTENT: Record<
    TRedirectReason | 'REQUEST_PIN',
    Record<TNotification['appearance'], TNotification>
  > = {
    VALIDATE_EMAIL_INIT_PASSWORD: {
      ERROR: {
        title: t('pages.auth.wording.fail'),
        message: t('pages.auth.notification.validate-email-init-password-error'),
        appearance: 'ERROR',
      },
      WARNING: {
        title: t('pages.auth.wording.warning'),
        message: t('pages.auth.notification.validate-email-init-password-warning'),
        appearance: 'WARNING',
      },
      SUCCESS: {
        title: t('pages.auth.wording.validated'),
        message: t('pages.auth.notification.validate-email-init-password-success'),
        appearance: 'SUCCESS',
      },
    },
    VALIDATE_EMAIL: {
      ERROR: {
        title: t('pages.auth.wording.fail'),
        message: t('pages.auth.notification.validate-email-error'),
        appearance: 'ERROR',
      },
      WARNING: {
        title: t('pages.auth.wording.warning'),
        message: t('pages.auth.notification.validate-email-warning'),
        appearance: 'WARNING',
      },
      SUCCESS: {
        title: t('pages.auth.wording.validated'),
        message: t('pages.auth.notification.validate-email-success'),
        appearance: 'SUCCESS',
      },
    },
    RESET_PASSWORD: {
      ERROR: {
        title: t('pages.auth.wording.fail'),
        message: t('pages.auth.notification.reset-password-error'),
        appearance: 'ERROR',
      },
      WARNING: {
        title: t('pages.auth.wording.warning'),
        message: t('pages.auth.notification.reset-password-warning'),
        appearance: 'WARNING',
      },
      SUCCESS: {
        title: t('pages.auth.wording.validated'),
        message: t('pages.auth.notification.reset-password-success'),
        appearance: 'SUCCESS',
      },
    },
    REQUEST_PIN: {
      ERROR: {
        title: t('pages.auth.wording.fail'),
        message: t('pages.auth.notification.request-pin-error'),
        appearance: 'ERROR',
      },
      WARNING: {
        title: t('pages.auth.wording.warning'),
        message: t('pages.auth.notification.request-pin-warning'),
        appearance: 'WARNING',
      },
      SUCCESS: {
        title: t('pages.auth.wording.validated'),
        message: t('pages.auth.notification.request-pin-success'),
        appearance: 'SUCCESS',
      },
    },
  }

  return NOTIFICATION_CONTENT
}
